import { render, staticRenderFns } from "./PutAway.vue?vue&type=template&id=ae126220&scoped=true&"
import script from "./PutAway.vue?vue&type=script&lang=js&"
export * from "./PutAway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae126220",
  null
  
)

export default component.exports